import { Dispatch, SetStateAction } from "react";

interface ColorControlsProps {
  colors: string[];
  currentColor: null| string;
  handleColorClick: (color: string) => void;
  setCurrentColor: Dispatch<SetStateAction<null|string>>;
}

const ColorControls: React.FC<ColorControlsProps> = ({
  colors,
  handleColorClick,
  setCurrentColor,
  currentColor
}) => {
  
  return (
    <div className="color-buttons flex mt-5 gap-3">
      {colors.map((color: string, index:number) => (
        <button
          className={`flex w-10 h-10 bg-cl-${color} rounded-full `}
          key={index}
          onClick={() => { handleColorClick(color) ; setCurrentColor(color)}}
          disabled={currentColor == color}
        ></button>
      ))}
    </div>
  );
}
 
export default ColorControls;
